type LatLng = { lat: number; lng: number }

function quadraticBezier(
  p0: LatLng,
  control: LatLng,
  p2: LatLng,
  t: number,
): LatLng {
  const u = 1 - t
  return {
    lat: u * u * p0.lat + 2 * u * t * control.lat + t * t * p2.lat,
    lng: u * u * p0.lng + 2 * u * t * control.lng + t * t * p2.lng,
  }
}

const SAMPLES = 30
const BULGE_FACTOR = 0.3

export function curvedPath(points: LatLng[]): LatLng[] {
  if (points.length < 2) return points

  const result: LatLng[] = []

  for (let i = 0; i < points.length - 1; i++) {
    const a = points[i]
    const b = points[i + 1]

    const midLat = (a.lat + b.lat) / 2
    const midLng = (a.lng + b.lng) / 2

    const dLat = b.lat - a.lat
    const dLng = b.lng - a.lng

    // Offset perpendicular to the segment to create the arch
    // Alternate direction per segment for visual variety
    const sign = i % 2 === 0 ? 1 : -1
    const control: LatLng = {
      lat: midLat + sign * dLng * BULGE_FACTOR,
      lng: midLng - sign * dLat * BULGE_FACTOR,
    }

    for (let s = 0; s <= SAMPLES; s++) {
      // Skip the first point of subsequent segments to avoid duplicates
      if (i > 0 && s === 0) continue
      result.push(quadraticBezier(a, control, b, s / SAMPLES))
    }
  }

  return result
}
